import { Box } from "@mui/material";
import type { Components } from "react-markdown";

/**
 * The one answer every page that renders markdown gives to a wide table.
 *
 * A markdown table is as wide as its columns need — the data-processing
 * agreement's five-column sub-processor table measures 581px — and a document
 * is read on a phone too. Scrolling the table inside its own box keeps every
 * column reachable while the document stays the width of the screen; widening
 * the page instead takes the navbar and every other control off screen with it.
 *
 * Hand it to `ReactMarkdown` as `components={MARKDOWN_TABLE_SCROLLER}`, or
 * spread it into a larger `components` object as the docs reader does.
 */
export const MARKDOWN_TABLE_SCROLLER: Components = {
	table({ node: _node, children, ...rest }) {
		return (
			<Box
				data-component="markdown-table-scroller"
				sx={{ overflowX: "auto", my: 2 }}
			>
				<table {...rest}>{children}</table>
			</Box>
		);
	},
};
